import { Link } from "react-router-dom";
import { WHATSAPP_NUMBER, CONTACT_EMAIL, WHATSAPP_LINK } from "../lib/api";
import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2 mb-5">
              <span className="font-display text-3xl font-medium tracking-tight">ROYALE</span>
              <span className="font-display text-3xl font-light tracking-tight text-[#9D8C70]">YAAN</span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed max-w-md">
              India&apos;s discerning marketplace for hand-picked pre-owned luxury automobiles.
              Every vehicle inspected, authenticated and assured.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Explore</p>
            <ul className="space-y-3 text-sm text-gray-700">
              <li><Link to="/inventory" className="hover:text-black">Inventory</Link></li>
              <li><Link to="/sell" className="hover:text-black">Sell Your Car</Link></li>
              <li><Link to="/about" className="hover:text-black">About</Link></li>
              <li><Link to="/contact" className="hover:text-black">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-5">Get in touch</p>
            <ul className="space-y-3 text-sm text-gray-700">
              <li className="flex items-center gap-3">
                <Phone size={15} strokeWidth={1.5} />
                <a href={`tel:+91${WHATSAPP_NUMBER}`} className="hover:text-black">+91 {WHATSAPP_NUMBER}</a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={15} strokeWidth={1.5} />
                <a href={WHATSAPP_LINK("Hello Royale Yaan")} target="_blank" rel="noreferrer" className="hover:text-black">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} strokeWidth={1.5} />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-black">{CONTACT_EMAIL}</a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={15} strokeWidth={1.5} />
                <a href="#" className="hover:text-black">@royaleyaan</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-y mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-xs text-gray-500">© {new Date().getFullYear()} Royale Yaan. All rights reserved.</p>
          <p className="text-xs text-gray-500">
            <Link to="/admin/login" className="hover:text-black" data-testid="footer-admin-link">Admin</Link>
            <span className="mx-3">·</span>
            <span>Curated in India</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
